
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personen/[slug]",
      function () {
        return require("private-next-pages/personen/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personen/[slug]"])
      });
    }
  